module.exports = __webpack_public_path__ + "static/img/8496_phase_function_Paper_PointsHejduk_Prediction.d4cb531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8496_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gig9
// module chunks = 0